import product from '@/views/apply/product.vue'

export default [
    {
        path: '/product',
        component: product,
        meta: { title: 'Confirmación de préstamo' }
    }
    
]